const pendingLoginReturnToKey = 'countbubble:pending-auth0-login-return-to';

const getSessionStorage = () => {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
};

const isSafeReturnTo = (returnTo: string | null | undefined): returnTo is string =>
    !!returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//');

export const getPendingLoginReturnTo = () => {
    const returnTo = getSessionStorage()?.getItem(pendingLoginReturnToKey);
    return isSafeReturnTo(returnTo) ? returnTo : null;
};

export const setPendingLoginReturnTo = (returnTo: string) => {
    if (isSafeReturnTo(returnTo)) {
        getSessionStorage()?.setItem(pendingLoginReturnToKey, returnTo);
    }
};

export const clearPendingLoginReturnTo = () => {
    getSessionStorage()?.removeItem(pendingLoginReturnToKey);
};
